import * as tslib_1 from "tslib";
import { JsonObject, JsonProperty } from "json2typescript";
import { Profile } from "./Profile";
let NewProfile = class NewProfile extends Profile {
    constructor() {
        super();
        this.verifyEmail = true; //Verify a persons email by default
        this.password = '';
    }
};
tslib_1.__decorate([
    JsonProperty('VerifyEmail', Boolean, false)
], NewProfile.prototype, "verifyEmail", void 0);
tslib_1.__decorate([
    JsonProperty('Password', String, false)
], NewProfile.prototype, "password", void 0);
NewProfile = tslib_1.__decorate([
    JsonObject
], NewProfile);
export { NewProfile };
